import ArrowIcon from '@/component/Icon/Arrow'
import Modal from '@/component/Modal'
import { KULEWEBVIEW } from '@/config/constant'
import useLinkTo from '@/hook/useLinkTo'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

const BackBtn: React.FC<PropType> = () => {
  const { t } = useTranslation()
  const { linkTo } = useLinkTo()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [modalVisible, setModalVisible] = useState(false)

  const isHome = () => {
    return pathname === '/' || /^\/[^\/]+\/$/.test(pathname)
  }

  const isLast = () => {
    return window.history.length === 1
  }

  const handleClick = () => {
    if (KULEWEBVIEW) {
      if (isHome()) {
        setModalVisible(true)
      } else if (isLast()) {
        // 跳转到首页
        linkTo('/')
      } else {
        navigate(-1)
      }
    } else {
      navigate(-1)
    }
  }

  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    KULEWEBVIEW && window.Bridge.system.finishPage()
  }

  return (
    <>
      <button className="flex h-full w-full items-center" onClick={handleClick}>
        {/* {MOBILE_ANDROID ? <BackSVG className="w-6 font-bold" /> : <ArrowIcon className="w-6" />} */}
        {<ArrowIcon className="w-7 stroke-primary-text stroke-[1.8]" />}
      </button>
      <Modal
        visible={modalVisible}
        title={t('title.exitGC')}
        okText={t('btn.exitGC')}
        cancelText={t('btn.stayGC')}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
      />
    </>
  )
}

interface PropType {}

export default BackBtn
